import styled from 'styled-components';
import FormControl from '@mui/material/FormControl';

export const Form = styled(FormControl)`
  width: 100%;
`;
